import styled from 'styled-components';
import { AllieCard, AllieText } from '../../../../../components';

export const QueryItemContainer = styled.div`
  display: flex;
  gap: var(--allie-spacing-md);
  align-self: stretch;
  justify-content: space-between;
  align-items: center;
`;

export const AllieCardStyled = styled(AllieCard)`
  margin: 0;
  box-shadow: var(--allie-shadow-md);
  cursor: pointer;

  &:hover {
    box-shadow: var(--allie-shadow-sm);
  }
`;

export const AllieTextStyled = styled(AllieText)<{ lineClamp?: number }>`
  ion-text {
    text-overflow: ellipsis;
    overflow: hidden;
    ${({ lineClamp }) =>
      lineClamp &&
      `-webkit-line-clamp: ${lineClamp}; display: -webkit-box; -webkit-box-orient: vertical;`};
  }
`;
